var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    version: "0.0.21",
    username: "taylor+taylor@haiku.ai",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.3.0",
    title: "Gal",
    type: "haiku",
    relpath: "code/gal/code.js"
  },
  options: {},
  states: { curFrame: { type: "number", value: 0, edited: true } },
  eventHandlers: {
    "haiku:Gal-2da483e1be06665f": {
      mousemove: {
        handler: function(component, element, target, event) {
          var totalFrames = 352;
          var x = this.evaluate("$user.mouse.x");
          var width = this.width * this.scale.x;
          if (x < 0) x = 0;
          if (x > width) x = width;
          var pc = x / width;
          var fr = Math.round(pc * totalFrames);
          this.gotoAndStop(fr);
          this.setState({ curFrame: fr });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().gotoAndPlay(this.state.curFrame);
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:linearGradient-4-2fb030-e96675cb471bfc38": {
        x1: "50%",
        y1: "100%",
        x2: "50%",
        y2: "3.061617e-15%"
      },
      "haiku:b39fe8953971": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 132,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 60,
        "sizeMode.y": 1,
        "translation.x": 115.7400061035156,
        "translation.y": 154.99400610351557,
        "style.zIndex": 1
      },
      "haiku:919b093ed6a8": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 67,
        "style.margin": "0",
        "sizeAbsolute.y": 136,
        "sizeMode.x": 1,
        "translation.x": 67.334,
        "translation.y": 172.931,
        "style.zIndex": 3,
        "origin.x": 0.836,
        "origin.y": 0.907,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
          "2200": { value: -0.087, curve: "easeInOutQuad", edited: true },
          "3117": { value: 0, edited: true }
        },
        "translation.z": 0
      },
      "haiku:668a294bcdbf": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 358,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 148,
        "sizeMode.y": 1,
        "translation.x": 242.74000610351558,
        "translation.y": 110.89399999999995,
        "style.zIndex": 4
      },
      "haiku:Gal-2da483e1be06665f": {
        "style.position": "relative",
        "sizeAbsolute.y": 185.496,
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 421.714,
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.backgroundColor": {
          "0": { value: "transparent", edited: true }
        },
        "style.cursor": { "0": { value: "ew-resize", edited: true } }
      },
      "haiku:36c515db7b4e": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 183,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 127,
        "sizeMode.y": 1,
        "translation.x": 219.73999999999998,
        "translation.y": 70.99399999999997,
        "style.zIndex": 5,
        "style.overflow": { "0": { value: "visible", edited: true } }
      },
      "haiku:69037c35c63c": {
        x1: "50%",
        y1: "-2.48949813e-15%",
        x2: "50%",
        y2: "99.0313403%"
      },
      "haiku:e34fd4eb2152": { stopColor: "#E99631", offset: "0%" },
      "haiku:5b6a86ffcafd": { stopColor: "#EED122", offset: "100%" },
      "haiku:6f7596bee8b7": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:debd39f765ae": {
        fill: "url(#401cb8023547)",
        fillRule: "nonzero",
        "translation.x": -157,
        "translation.y": -487
      },
      "haiku:3e62c7fb8d10": {
        d: {
          "0": {
            value:
              "M159.695649,533.807347 C153.787355,512.872512 157.591363,498.758527 171.107673,491.465391 C191.382139,480.525686 211.48565,492.191466 219.320152,499.772797 C227.154655,507.354129 239.495929,500.616443 250.274852,505.345124 C261.053775,510.073806 267.905871,524.564122 284.303487,533.807347 C300.701102,543.050571 317.247912,528.078409 334.885497,556.188893 C352.523081,584.299377 312.540087,604.873975 305.820922,607.107407 C299.101757,609.340839 278.400736,616.710522 262.234961,611.885275 C246.069187,607.060028 241.105566,593.441996 227.154655,583.626678 C213.203744,573.81136 202.521078,577.080729 195.992291,565.98589 C189.738689,555.358692 205.363993,551.658279 201.589877,540.182603 C199.114043,532.654519 188.252083,534.583669 183.45557,528.078409 C173.34351,514.363951 165.423536,516.273596 159.695649,533.807347 Z",
            edited: true,
            curve: "linear"
          },
          "1217": {
            value:
              "M159.695649,533.807347C150.67497915835446,512.5266924826519,159.3204606898031,497.37524893060737,171.107673,491.465391C189.6530413101969,481.90896406939265,209.61260215391712,490.942767510373,217.44710415391714,498.52409851037305C225.28160715391712,506.105430510373,236.24897357056724,499.23316493060736,251.52355056405526,505.345124C266.79812755754324,511.45708406939264,269.91349843387,530.1645240674534,284.9278362820276,533.1829977551865C299.94217313018515,536.2014704429196,326.3737995747631,532.0936636284123,333.63679843594474,557.437591489627C340.8997962971264,582.7815193508418,320.42664657920056,607.6499017067194,306.44527128202765,610.2291532240675C292.4638959848548,612.8084047414156,281.9935109673934,615.951593175421,260.98626243594475,612.5096242448136C239.97901490449613,609.0676553142063,240.83640682442555,591.1652095262626,229.65205212811045,585.4997257344405C218.4676974317954,579.8342419426185,202.79960774406698,581.1632734182951,196.6166402820276,566.6102392448136C190.7088578199882,552.5248460713319,205.363993,551.658279,201.589877,540.182603C199.114043,532.654519,188.94372207592127,533.8920299653037,183.45557,528.078409C172.65187092407874,515.0555900346964,168.53591184164554,516.6194155173481,159.695649,533.807347Z",
            edited: true,
            curve: "linear"
          },
          "3017": {
            value:
              "M159.695649,533.807347C153.04730945236295,512.7902847218304,155.17863457263852,494.1938208757215,170.16638471909485,490.9947468876C191.91229086555117,484.1491038994785,208.6870651163111,491.8945565634131,218.87478781857394,501.8291081254131C229.06251152083675,511.763660687413,246.72483416205748,507.81783968572125,262.8085091060508,514.2873621355998C278.8921840500441,520.7568855854786,278.7374059493818,532.9554199747603,297.15933351936144,540.2479098553065C315.5812600893411,547.5403987358527,321.77104174010225,552.5653422819437,327.5289254389274,569.1931934713866C333.2868081377525,585.8210446608296,323.35755334022735,609.2991742124976,308.32259742940494,615.3799863898671C293.2876415185825,621.4607985672366,275.9604995255389,620.2952205048147,260.99676326481085,612.5043738306933C246.03302800408275,604.713527156572,249.04251703169555,600.4309386152443,225.86589734675783,585.9546186044802C202.68927766182014,571.4782985937162,202.58730544407123,578.05145649999,196.14074572714202,566.1343447182935C189.9693710102128,554.6848739365969,205.363993,551.658279,201.589877,540.182603C199.114043,532.654519,188.41653756614159,534.4192144436607,183.45557,528.078409C173.17905543385842,514.5284055563393,166.16358154763705,516.3558232781696,159.695649,533.807347Z",
            edited: true,
            curve: "linear"
          },
          "5833": {
            value:
              "M159.695649,533.807347C153.787355,512.872512,157.591363,498.758527,171.107673,491.465391C191.382139,480.525686,211.48565,492.191466,219.320152,499.772797C227.154655,507.354129,239.495929,500.616443,250.274852,505.345124C261.053775,510.073806,267.905871,524.564122,284.303487,533.807347C300.701102,543.050571,317.247912,528.078409,334.885497,556.188893C352.523081,584.299377,312.540087,604.873975,305.820922,607.107407C299.101757,609.340839,278.400736,616.710522,262.234961,611.885275C246.069187,607.060028,241.105566,593.441996,227.154655,583.626678C213.203744,573.81136,202.521078,577.080729,195.992291,565.98589C189.738689,555.358692,205.363993,551.658279,201.589877,540.182603C199.114043,532.654519,188.252083,534.583669,183.45557,528.078409C173.34351,514.363951,165.423536,516.273596,159.695649,533.807347Z",
            edited: true
          }
        },
        "translation.x": 496.34,
        "rotation.x": 3.142,
        "scale.x": -1,
        "scale.y": -1,
        "scale.z": -1
      },
      "haiku:path-1-1e273b-c1fcd792f412a562": {
        d:
          "M77.6191652,122.928044 C77.4785515,137.280432 53.8075559,147.62878 47.2870172,129.410099 C43.0328127,109.435736 37.9371402,81.0867773 32,44.3632235 L46.4283609,39 C69.2008232,70.9652777 79.5977579,98.9412925 77.6191652,122.928044 Z"
      },
      "haiku:pattern-3-1e273b-266ad47999201c51": {
        width: 11.52,
        height: 11.52,
        x: 20.48,
        y: 27.48,
        patternUnits: "userSpaceOnUse"
      },
      "haiku:Use-4ad6ac4cdeccf14a": {
        "xlink:href": "#image-4-1e273b",
        "scale.x": 0.36,
        "scale.y": 0.36
      },
      "haiku:image-4-1e273b-218f540535b93200": {
        width: 32,
        height: 32,
        "xlink:href":
          "web+haikuroot://assets/designs/heroine.sketch.contents/slices/Leg1_image_1.png"
      },
      "haiku:Page-1-2ebcfa1f267783d4": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-1b716d0dc5a094e3": {
        "translation.x": -46,
        "translation.y": -529
      },
      "haiku:Leg1-b5644b9cbeed43c3": {
        "translation.x": 35,
        "translation.y": 525
      },
      "haiku:Group-2-Copy-cb9712849ef6773b": {
        fillRule: "nonzero",
        "translation.x": 36.981,
        "translation.y": 49.505,
        "rotation.z": 3.857
      },
      "haiku:Path-10-eb2931718976faa7": {
        fill: "#FFE754",
        points:
          "0 13.9325623 7.76517852 0 15.9705127 6.96628114 9.35479473 18.0382034"
      },
      "haiku:Path-11-054de94fb6c344b4": {
        d:
          "M15.7815198,6 C36.9045304,14.5622171 46.3500329,10.2878001 48.0824022,18.4775207 C40.6220613,19.8901824 20.3601144,22.6775871 15.7815198,22.6775871 C12.7291235,22.6775871 10.4686169,21.2775649 9,18.4775207 C10.4661942,13.017707 12.7267008,8.85853342 15.7815198,6 Z",
        fill: "#9241BE"
      },
      "haiku:mask-2-d86487dc99fa7d32": { fill: "white" },
      "haiku:Use-d7dc3746aed0936e": { "xlink:href": "#path-1-1e273b" },
      "haiku:Mask-9675505e17cd824e": { fillRule: "nonzero" },
      "haiku:Use-89e9757a19e82226": {
        fill: "#DE5082",
        "xlink:href": "#path-1-1e273b"
      },
      "haiku:Use-b66155b1512fb0c6": {
        fill: "url(#pattern-3-1e273b)",
        "xlink:href": "#path-1-1e273b"
      },
      "haiku:Page-1-50d311913dc8c9a1": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-a6824d0c3e777fd9": {
        fillRule: "nonzero",
        "translation.x": -100,
        "translation.y": -493
      },
      "haiku:Leg2-03df6511fe1c5b4c": {
        "translation.x": 64,
        "translation.y": 490
      },
      "haiku:Path-9-Copy-0b14d39b01ab31b4": {
        d:
          "M12.1716694,88.5821702 C26.0743664,108.228903 52.0215162,122.976753 90.0131188,132.82572 L97.6184709,119.442881 C69.4649122,95.1273264 47.3390414,76.6861994 31.2408584,64.1194994 C14.5350938,54.3545017 3.05384864,77.4972185 12.1716694,88.5821702 Z",
        fill: "#CD3172",
        "translation.x": -2.671,
        "translation.y": 193.086,
        "rotation.z": 4.171
      },
      "haiku:Group-2-2f773a59d7516474": {
        "translation.x": 52.756,
        "translation.y": 54.007,
        "rotation.z": 4.206
      },
      "haiku:Path-10-ea93a2a4b7bea4a9": {
        fill: "#FFE754",
        points:
          "0 13.9325623 7.76517852 0 15.9705127 6.96628114 9.35479473 18.0382034"
      },
      "haiku:Path-11-99a3e423a1d57d54": {
        d:
          "M15.7815198,6 C36.9045304,14.5622171 46.3500329,10.2878001 48.0824022,18.4775207 C40.6220613,19.8901824 20.3601144,22.6775871 15.7815198,22.6775871 C12.7291235,22.6775871 10.4686169,21.2775649 9,18.4775207 C10.4661942,13.017707 12.7267008,8.85853342 15.7815198,6 Z",
        fill: "#9241BE"
      },
      "haiku:path-1-2fb030-5309d78ffddeaac3": {
        d:
          "M108.615472,169.966797 C73.8159849,169.793646 40.857469,169.723557 9.73992416,169.756531 C-2.57730434,169.025399 -4.8078937,152.419117 15.2434538,138.854127 C57.5362387,110.242523 112.436121,100.985219 131.687663,121.201728 C130.056061,136.547007 122.365331,152.802029 108.615472,169.966797 Z"
      },
      "haiku:pattern-2-2fb030-5be643f8cd90ba73": {
        width: 11.5294118,
        height: 11.5294118,
        x: -11.2071645,
        y: 98.823033,
        patternUnits: "userSpaceOnUse"
      },
      "haiku:Use-46535711a3657eba": {
        "xlink:href": "#image-3-2fb030",
        "scale.x": 0.36,
        "scale.y": 0.36
      },
      "haiku:image-3-2fb030-eacc07dde5047898": {
        width: 32,
        height: 32,
        "xlink:href":
          "web+haikuroot://assets/designs/heroine.sketch.contents/slices/heroine_image_1.png"
      },
      "haiku:c5e7e3284e1e": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 38,
        "style.margin": "0",
        "sizeAbsolute.y": 145,
        "sizeMode.x": 1,
        "translation.x": 69.624,
        "translation.y": 169.907,
        "style.zIndex": 2,
        "origin.x": 0.548,
        "origin.y": 0.936,
        "rotation.z": {
          "0": { value: 0, edited: true },
          "517": { value: 0, edited: true, curve: "easeInOutQuad" },
          "2267": { value: -0.073, edited: true, curve: "easeInOutQuad" },
          "3367": { value: 0, edited: true, curve: "easeInOutQuad" },
          "4317": { value: -0.022, edited: true, curve: "easeInOutQuad" },
          "5867": { value: 0, edited: true }
        },
        "translation.z": 0
      },
      "haiku:Stop-dee8868b00e46382": { stopColor: "#F6DBCE", offset: "0%" },
      "haiku:Stop-185c5a44725f704c": { stopColor: "#F8CBB5", offset: "100%" },
      "haiku:path-5-2fb030-c780d3575eb4ee01": {
        d:
          "M5.70719567,29.6429263 C12.0739579,34.4939392 17.1269682,37.7120626 20.8662266,39.2972966 C30.9707099,32.7900278 39.3484354,20.968765 39.3484354,14.4504278 C36.2823335,11.2291098 31.5586383,7.96095888 25.1773498,4.6459749 C14.7890862,-0.0562301208 7.13931749,1.69779627 2.22804359,9.90805408 C-2.68323031,18.1183119 -1.52351295,24.6966026 5.70719567,29.6429263 Z"
      },
      "haiku:pattern-7-2fb030-148247e65b48a0d5": {
        width: 11.52,
        height: 11.52,
        x: -12.271776,
        y: -9.44255897,
        patternUnits: "userSpaceOnUse"
      },
      "haiku:Use-691f9deb428cc73c": {
        "xlink:href": "#image-8-2fb030",
        "scale.x": 0.36,
        "scale.y": 0.36
      },
      "haiku:image-8-2fb030-a72daf3639f208b7": {
        width: 32,
        height: 32,
        "xlink:href":
          "web+haikuroot://assets/designs/heroine.sketch.contents/slices/heroine_image_2.png"
      },
      "haiku:Page-1-790e7a3d0971e7ca": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-2f0c834c4c89a03f": {
        "translation.x": -93,
        "translation.y": -516
      },
      "haiku:heroine-e92ae07c06e4040f": {
        "translation.x": 93,
        "translation.y": 494
      },
      "haiku:Mask-4c3b50f440a9ff5d": { fillRule: "nonzero" },
      "haiku:Use-1d4e4e51b518b827": {
        fill: "#DE5082",
        "xlink:href": "#path-1-2fb030"
      },
      "haiku:Use-1aba57af97120077": {
        fill: "url(#pattern-2-2fb030)",
        "xlink:href": "#path-1-2fb030"
      },
      "haiku:upper-body-b43c738534fe5efd": {
        fillRule: "nonzero",
        "translation.x": 104,
        "translation.y": 78
      },
      "haiku:Path-12-Copy-7d2d8baf8e6c8685": {
        d:
          "M108.875603,38.3236698 C114.314667,42.4678439 118.631406,45.2170561 121.825819,46.5713065 C130.457983,41.0122086 137.614994,30.9134163 137.614994,25.3448629 C134.995652,22.5929216 130.960244,19.8009714 125.50877,16.9690121 C116.634176,12.9519631 110.099051,14.4504112 105.903396,21.4643563 C101.707742,28.4783014 102.698477,34.0980725 108.875603,38.3236698 Z",
        fill: "#DE5082",
        "translation.x": 85.627,
        "translation.y": -88.669,
        "rotation.x": 3.142,
        "rotation.z": 4.677,
        "scale.x": -1,
        "scale.y": -1,
        "scale.z": -1
      },
      "haiku:body-copy-794d27b318c2def0": {
        d:
          "M114.874412,6.50841135 C111.396115,2.14508496 95.1972129,-7.0800629 65.871545,14.8190237 C46.3210997,29.4184148 32.4138014,38.2959866 24.14965,41.4517392 C1.08452744,75.0581404 -5.33678826,91.8613411 4.88570294,91.8613411 C46.1617102,92.1228264 101.116577,79.1588022 117.573112,50.0903422 C134.029647,21.0218821 118.352709,10.8717378 114.874412,6.50841135 Z",
        fill: "#FF6EA8"
      },
      "haiku:face-7073444f3c3da560": {
        fillRule: "nonzero",
        "translation.x": 199,
        "translation.y": 22
      },
      "haiku:Group-be53e9a6a7b7690c": { fill: "url(#linearGradient-4-2fb030)" },
      "haiku:neck-1bd5ec748630f349": {
        d:
          "M24.2134489,54.3977732 C24.2134489,60.8265993 24.2134489,65.239454 24.2134489,67.6363373 C24.2134489,90.3753954 3.9446207,77.5529846 0.903559718,62.9979006 C4.89679137,52.0655754 11.8009336,47.4853921 10.0874011,39.3546572 C8.94504607,33.9341673 13.6537287,38.9485393 24.2134489,54.3977732 Z"
      },
      "haiku:facel-0fd18c3031f3214f": {
        d:
          "M44.753928,17.9626703 C44.753928,32.490862 48.770227,46.371956 32.5483954,55.0095832 C16.3265639,63.6472104 2.10067998,35.5721929 2.10067998,29.7067221 C2.10067998,26.3593617 -1.58595127,12.9006073 9.56799756,11.234073 C13.9033516,10.5863189 30.5026251,-1.46430096 37.9853122,1.09171175 C44.9848061,3.48267035 44.753928,14.1768067 44.753928,17.9626703 Z"
      },
      "haiku:glasses-881f0e5998d8610b": {
        fill: "#9241BE",
        "translation.x": 53,
        "translation.y": 16,
        "rotation.x": 3.142,
        "scale.x": -1,
        "scale.y": -1,
        "scale.z": -1
      },
      "haiku:Oval-5-1f94a7f0618ba984": { cx: 8.5, cy: 12.5, rx: 8.5, ry: 12.5 },
      "haiku:Oval-5-Copy-cb39cdbfa7ff7c4c": {
        cx: 29.5,
        cy: 12.5,
        rx: 9.5,
        ry: 12.5
      },
      "haiku:Path-7-015e4e50bf0deb1d": {
        d:
          "M19.6655797,10.7539191 C18.3944371,9.95381516 16.2818948,10 15.1999559,10.7539191 C14.118017,11.5078383 13.3526813,9.9731 14.7832905,9.47023319 C16.2138998,8.96736638 18.0342893,8.73025602 19.9079969,9.47023319 C21.7817044,10.2102104 20.9367222,11.5540231 19.6655797,10.7539191 Z"
      },
      "haiku:computer-ccfaadf20675fe05": {
        d:
          "M241.136419,92 L353.300476,92 C355.509615,92 357.300476,93.790861 357.300476,96 C357.300476,96.3829835 357.245474,96.763982 357.137154,97.1313281 L336.496129,167.131328 C335.994553,168.832325 334.432857,170 332.659451,170 L219,170 C216.790861,170 215,168.209139 215,166 C215,165.617017 215.055002,165.236018 215.163322,164.868672 L235.381403,96.3030079 C236.133767,93.7515118 238.476309,92 241.136419,92 Z",
        fill: "#C0CCCD",
        fillRule: "nonzero"
      },
      "haiku:arm-0af1635a6a5d8a24": {
        "translation.x": 135,
        "translation.y": 88
      },
      "haiku:Path-13-ebb2864df676db93": {
        d:
          "M37.4199875,22.6001859 C29.9601129,29.9678047 6.52121569,61.5995928 3.22067422,68.0248554 C-0.0798672435,74.4501181 3.22067422,81.4603297 14.2465909,73.2256977 C25.2725075,64.9910657 57.0739945,42.5476602 59.7284969,31.1719744 C62.3829994,19.7962885 44.8798621,15.2325672 37.4199875,22.6001859 Z",
        fill: "url(#linearGradient-4-2fb030)",
        fillRule: "nonzero",
        "translation.x": -2.469,
        "translation.y": 1.688,
        "rotation.z": 6.231
      },
      "haiku:Path-14-9362700b809be304": {
        d:
          "M77.7037565,71.9752657 C55.2285554,68.2390087 38.9573238,65.947889 28.8900616,65.1019067 C13.7891684,63.8329332 1.49307859,74.7669321 5.91086734,78.3428722 C8.85605984,80.7268323 32.7870229,81.5716553 77.7037565,80.877341 L77.7037565,71.9752657 Z",
        fill: "url(#linearGradient-4-2fb030)",
        fillRule: "nonzero"
      },
      "haiku:Path-15-e4485487ffa0e32e": {
        d:
          "M76.2239943,81.1690212 C73.5678972,74.3896737 75.2346461,71 81.2242409,71 C90.2086332,71 105.661394,76.9460702 103.427032,79.0575457 C101.937457,80.465196 92.869778,81.1690212 76.2239943,81.1690212 Z",
        fill: "url(#linearGradient-4-2fb030)",
        fillRule: "nonzero"
      },
      "haiku:Group-5-a1602ba23de26781": { "translation.x": 31 },
      "haiku:mask-6-f47a8945828c9dd0": { fill: "white" },
      "haiku:Use-ac8ce32b41c52e24": { "xlink:href": "#path-5-2fb030" },
      "haiku:Mask-84948c58058a97f4": {
        fillRule: "nonzero",
        "translation.x": 40.647,
        "translation.y": 2.123,
        "rotation.z": 1.606
      },
      "haiku:Use-94cf32290f005157": {
        fill: "#DE5082",
        "xlink:href": "#path-5-2fb030"
      },
      "haiku:Use-b613e21a28fa8b69": {
        fill: "url(#pattern-7-2fb030)",
        "xlink:href": "#path-5-2fb030"
      },
      "haiku:Page-1-076fcb686481e320": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-cc5915dd746d59e1": {
        fill: "#CD3172",
        fillRule: "nonzero",
        "translation.x": -83,
        "translation.y": -600
      },
      "haiku:legback-096e1f35a5a11405": {
        d:
          "M138.0064,595 C164.545741,617.463034 189.741434,638.665912 213.593478,658.608634 C222.55659,667.071651 213.593478,681.202511 189.520481,678.709388 C138.745137,673.450833 90.7521322,645.301354 89,617.487363 C100.110572,606.799189 116.446039,599.303401 138.0064,595 Z",
        "translation.x": 679.661,
        "translation.y": 1026.624,
        "rotation.z": 2.443
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Gal-2da483e1be06665f", "haiku-title": "Gal" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "36c515db7b4e",
          "haiku-title": "hair",
          "haiku-source": "designs/heroine.sketch.contents/slices/hair.svg#lock"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "f42d8dd6373c" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "69037c35c63c",
                  "haiku-title": "linearGradient-1-a0640f",
                  id: "401cb8023547"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "e34fd4eb2152" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "5b6a86ffcafd" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: {
              "haiku-id": "6f7596bee8b7",
              "haiku-title": "Page-1",
              id: "29e3b1c47298"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "debd39f765ae",
                  "haiku-title": "Artboard-Copy-9",
                  id: "4fa99f9b3978"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "3e62c7fb8d10",
                      "haiku-title": "hair",
                      id: "cf1edd2102e5"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "668a294bcdbf",
          "haiku-title": "heroine",
          "haiku-source": "designs/heroine.sketch.contents/slices/heroine.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-8d630c446e1facf7" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "path-1-2fb030-5309d78ffddeaac3",
                  id: "path-1-2fb030"
                },
                children: []
              },
              {
                elementName: "pattern",
                attributes: {
                  "haiku-id": "pattern-2-2fb030-5be643f8cd90ba73",
                  id: "pattern-2-2fb030"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-46535711a3657eba" },
                    children: []
                  }
                ]
              },
              {
                elementName: "image",
                attributes: {
                  "haiku-id": "image-3-2fb030-eacc07dde5047898",
                  id: "image-3-2fb030"
                },
                children: []
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "linearGradient-4-2fb030-e96675cb471bfc38",
                  id: "linearGradient-4-2fb030"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-dee8868b00e46382" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-185c5a44725f704c" },
                    children: []
                  }
                ]
              },
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "path-5-2fb030-c780d3575eb4ee01",
                  id: "path-5-2fb030"
                },
                children: []
              },
              {
                elementName: "pattern",
                attributes: {
                  "haiku-id": "pattern-7-2fb030-148247e65b48a0d5",
                  id: "pattern-7-2fb030"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-691f9deb428cc73c" },
                    children: []
                  }
                ]
              },
              {
                elementName: "image",
                attributes: {
                  "haiku-id": "image-8-2fb030-a72daf3639f208b7",
                  id: "image-8-2fb030"
                },
                children: []
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-790e7a3d0971e7ca", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-2f0c834c4c89a03f",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "heroine-e92ae07c06e4040f",
                      id: "heroine"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Mask-4c3b50f440a9ff5d",
                          id: "Mask"
                        },
                        children: [
                          {
                            elementName: "use",
                            attributes: { "haiku-id": "Use-1d4e4e51b518b827" },
                            children: []
                          },
                          {
                            elementName: "use",
                            attributes: { "haiku-id": "Use-1aba57af97120077" },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "upper-body-b43c738534fe5efd",
                          id: "upper-body"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-12-Copy-7d2d8baf8e6c8685",
                              id: "Path-12-Copy"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "body-copy-794d27b318c2def0",
                              id: "body-copy"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "face-7073444f3c3da560",
                          id: "face"
                        },
                        children: [
                          {
                            elementName: "g",
                            attributes: {
                              "haiku-id": "Group-be53e9a6a7b7690c"
                            },
                            children: [
                              {
                                elementName: "path",
                                attributes: {
                                  "haiku-id": "neck-1bd5ec748630f349",
                                  id: "neck"
                                },
                                children: []
                              },
                              {
                                elementName: "path",
                                attributes: {
                                  "haiku-id": "facel-0fd18c3031f3214f",
                                  id: "facel"
                                },
                                children: []
                              }
                            ]
                          },
                          {
                            elementName: "g",
                            attributes: {
                              "haiku-id": "glasses-881f0e5998d8610b",
                              id: "glasses"
                            },
                            children: [
                              {
                                elementName: "ellipse",
                                attributes: {
                                  "haiku-id": "Oval-5-1f94a7f0618ba984",
                                  id: "Oval-5"
                                },
                                children: []
                              },
                              {
                                elementName: "ellipse",
                                attributes: {
                                  "haiku-id": "Oval-5-Copy-cb39cdbfa7ff7c4c",
                                  id: "Oval-5-Copy"
                                },
                                children: []
                              },
                              {
                                elementName: "path",
                                attributes: {
                                  "haiku-id": "Path-7-015e4e50bf0deb1d",
                                  id: "Path-7"
                                },
                                children: []
                              }
                            ]
                          }
                        ]
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "computer-ccfaadf20675fe05",
                          id: "computer"
                        },
                        children: []
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "arm-0af1635a6a5d8a24",
                          id: "arm"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-13-ebb2864df676db93",
                              id: "Path-13"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-14-9362700b809be304",
                              id: "Path-14"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-15-e4485487ffa0e32e",
                              id: "Path-15"
                            },
                            children: []
                          },
                          {
                            elementName: "g",
                            attributes: {
                              "haiku-id": "Group-5-a1602ba23de26781",
                              id: "Group-5"
                            },
                            children: [
                              {
                                elementName: "mask",
                                attributes: {
                                  "haiku-id": "mask-6-f47a8945828c9dd0",
                                  id: "mask-6"
                                },
                                children: [
                                  {
                                    elementName: "use",
                                    attributes: {
                                      "haiku-id": "Use-ac8ce32b41c52e24"
                                    },
                                    children: []
                                  }
                                ]
                              },
                              {
                                elementName: "g",
                                attributes: {
                                  "haiku-id": "Mask-84948c58058a97f4",
                                  id: "Mask"
                                },
                                children: [
                                  {
                                    elementName: "use",
                                    attributes: {
                                      "haiku-id": "Use-94cf32290f005157"
                                    },
                                    children: []
                                  },
                                  {
                                    elementName: "use",
                                    attributes: {
                                      "haiku-id": "Use-b613e21a28fa8b69"
                                    },
                                    children: []
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "919b093ed6a8",
          "haiku-title": "Leg1",
          "haiku-source": "designs/heroine.sketch.contents/slices/Leg1.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-a5080f52ce4f9741" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "path-1-1e273b-c1fcd792f412a562",
                  id: "path-1-1e273b"
                },
                children: []
              },
              {
                elementName: "pattern",
                attributes: {
                  "haiku-id": "pattern-3-1e273b-266ad47999201c51",
                  id: "pattern-3-1e273b"
                },
                children: [
                  {
                    elementName: "use",
                    attributes: { "haiku-id": "Use-4ad6ac4cdeccf14a" },
                    children: []
                  }
                ]
              },
              {
                elementName: "image",
                attributes: {
                  "haiku-id": "image-4-1e273b-218f540535b93200",
                  id: "image-4-1e273b"
                },
                children: []
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-2ebcfa1f267783d4", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-1b716d0dc5a094e3",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Leg1-b5644b9cbeed43c3",
                      id: "Leg1"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Group-2-Copy-cb9712849ef6773b",
                          id: "Group-2-Copy"
                        },
                        children: [
                          {
                            elementName: "polygon",
                            attributes: {
                              "haiku-id": "Path-10-eb2931718976faa7",
                              id: "Path-10"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-11-054de94fb6c344b4",
                              id: "Path-11"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "mask",
                        attributes: {
                          "haiku-id": "mask-2-d86487dc99fa7d32",
                          id: "mask-2"
                        },
                        children: [
                          {
                            elementName: "use",
                            attributes: { "haiku-id": "Use-d7dc3746aed0936e" },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Mask-9675505e17cd824e",
                          id: "Mask"
                        },
                        children: [
                          {
                            elementName: "use",
                            attributes: { "haiku-id": "Use-89e9757a19e82226" },
                            children: []
                          },
                          {
                            elementName: "use",
                            attributes: { "haiku-id": "Use-b66155b1512fb0c6" },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "c5e7e3284e1e",
          "haiku-title": "Leg2",
          "haiku-source": "designs/heroine.sketch.contents/slices/Leg2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-50d311913dc8c9a1", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-a6824d0c3e777fd9",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Leg2-03df6511fe1c5b4c",
                      id: "Leg2"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-9-Copy-0b14d39b01ab31b4",
                          id: "Path-9-Copy"
                        },
                        children: []
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Group-2-2f773a59d7516474",
                          id: "Group-2"
                        },
                        children: [
                          {
                            elementName: "polygon",
                            attributes: {
                              "haiku-id": "Path-10-ea93a2a4b7bea4a9",
                              id: "Path-10"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-11-99a3e423a1d57d54",
                              id: "Path-11"
                            },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "b39fe8953971",
          "haiku-title": "legback",
          "haiku-source": "designs/heroine.sketch.contents/slices/legback.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-076fcb686481e320", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-cc5915dd746d59e1",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "legback-096e1f35a5a11405",
                      id: "legback"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/gal/code.js
// module id = 519
// module chunks = 35783957827783